import * as React from 'react'
import {Alert, Button, Checkbox, Col, Form, Icon, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectMemberItem, NewProjectMemberStore} from 'src/stores/projectmembers-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from 'src/core/services/http.service';
import EmployeeProjectEditor from 'src/components/employee-project-editor';
import EditableTooltip from '../../../../components/editable-tooltip/tooltip';

let FormItem = Form.Item;

interface NewProjectMemberViewProps {
    companyId: string,
    projectId: string,
    onClose: (id: string | undefined, item?: NewProjectMemberItem) => void;
    onRefreshRequired?: () => void;
    onAddAllEmployees: () => void;
    
}

interface NewProjectMemberViewState {

}

interface ClassFormBodyProps extends WithTranslation {
    companyId: string,
    projectId: string,
    item: NewProjectMemberItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
}

export class ProjectMemberFormBody extends React.Component<ClassFormBodyProps> {
    render() {
        const { t } = this.props;

        var item = this.props.item || {} as NewProjectMemberItem;
        return <Form id="modaForm" onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }} onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={24}>
                <Col span={24}>
                    
                    <FormItem label={t("Employee")}>
                        {this.props.getFieldDecorator(nameof<NewProjectMemberItem>('employeeId'), {
                            initialValue: item.employeeId,
                            rules: [{ required: true, message: t('Employee required') }],
                        })(
                            <EmployeeProjectEditor placeholder={t("Member")} companyId={this.props.companyId} projectId={this.props.projectId}/>
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <EditableTooltip name='new-member-is-manager' noIcon>
                        <FormItem>
                            {this.props.getFieldDecorator('isManager', {
                                rules: [], initialValue: (item.permission & 2) == 2, valuePropName: 'checked'
                            })(
                                <Checkbox><span>{t("Is Project manager")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft:3 }} /></Checkbox>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>
        </Form>
    }
}

@connect(["newProjectMember", NewProjectMemberStore])
class NewProjectMemberView extends React.Component<NewProjectMemberViewProps & WithTranslation & FormComponentProps, NewProjectMemberViewState> {
    private get newProjectMemberStore() {
        return (this.props as any).newProjectMember as NewProjectMemberStore;
    }

    constructor(props: NewProjectMemberViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.newProjectMemberStore.createNew({} as any);
        this.newProjectMemberStore.changeUrl(this.props.companyId, this.props.projectId);
    }

    componentWillReceiveProps(nextProps: NewProjectMemberViewProps) {
        if (this.newProjectMemberStore.state.result && this.newProjectMemberStore.state.result.isSuccess)
            nextProps.onClose((this.newProjectMemberStore.state.result as any).aggregateRootId, this.newProjectMemberStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (values.isManager) {
                    values.permission = 7
                } else {
                    values.permission = 1
                }
                if (!event) {
                    values = { ...values, projectId: this.props.projectId };
                    self.newProjectMemberStore.change(values);
                    self.newProjectMemberStore.submit().then(result => {
                        if (result.isSuccess) {
                            if (this.props.onRefreshRequired) {
                                this.props.onRefreshRequired()
                            }
                            resolve();
                            this.countDownNotification(notification.success, t("Notification"), t("Project member successfully added"), "succes")
                            if (this.props.onClose) {
                                this.props.onClose(result.identifier)
                            }
                        } else {
                            reject();
                            this.countDownNotification(notification.error, t("Error"), t("There was an error adding project member"), "fail")
                        }
                    });
                }
            });
        })
    }
    
    @autobind
    private onCancelNewItem() {
        this.newProjectMemberStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New project member")}>
                {this.newProjectMemberStore.state.result && !this.newProjectMemberStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={formatMessage(this.newProjectMemberStore.state.result)}
                    />
                }
                <Spin spinning={this.newProjectMemberStore.state.isBusy}>
                    <EditableTooltip name='project-members-add-all-employees' noIcon>
                        <Button  onClick={this.props.onAddAllEmployees} icon={'usergroup-add'}>
                            <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} />
                        </Button>
                    </EditableTooltip>
                    <ProjectMemberFormBody companyId={this.props.companyId} projectId={this.props.projectId} i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady} item={this.newProjectMemberStore.state.item} getFieldDecorator={getFieldDecorator} onSave={this.onCreateNewItem} />
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectMemberView as any) as any) as any as React.ComponentClass<NewProjectMemberViewProps>;